import { initializeApp } from 'firebase/app'
// import { getFunctions, connectFunctionsEmulator } from 'firebase/functions'
// import { getAuth, connectAuthEmulator } from 'firebase/auth'
// import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore'
// import { getStorage, connectStorageEmulator } from 'firebase/storage'

import { getFunctions } from 'firebase/functions'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'

const config = {
  apiKey: process.env.REACT_APP_APIKEY,
  authDomain: process.env.REACT_APP_AUTHDOMAIN,
  projectId: process.env.REACT_APP_PROJECTID,
  storageBucket: process.env.REACT_APP_STORAGEBUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
  appId: process.env.REACT_APP_APPID,
}

const FirebaseApp = initializeApp(config, {
  ignoreUndefinedProperties: true,
})

const functions = getFunctions(FirebaseApp, 'asia-southeast1')
const auth = getAuth()
const db = getFirestore()
const storage = getStorage()

// if (window.location.hostname === 'localhost') {
//   connectAuthEmulator(auth, 'http://localhost:9099')
//   connectFunctionsEmulator(functions, 'localhost', 5001)
//   connectFirestoreEmulator(db, 'localhost', 8080)
//   connectStorageEmulator(storage, 'localhost', 9199)
// }

export { functions, auth, storage, db }
